import './index.less';



/** WEBPACK FOOTER **
 ** ./components/icon/style/index.web.tsx
 **/